import React, { useState } from 'react';
import { Paper, Typography, useMediaQuery, useTheme } from '@mui/material';

import {
  BackdropForDialog,
  CloseButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  SubmitButton,
} from 'components';
import { UserSettingsForm, NotificationsForm } from 'forms';

interface UserUpdateDialogProps {
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  userId: number;
}

export const UserUpdateDialog = ({ visible = false, setVisible = () => {}, userId }: UserUpdateDialogProps) => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));
  const [loading_form, setLoadingForm] = useState<boolean>(false);
  const [loading_submit, setLoadingSubmit] = useState<boolean>(false);
  const formRef = React.useRef<any>();

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <Dialog onClose={onClose} open={visible} PaperProps={{ style: { overflow: 'visible', boxShadow: 'none' } }}>
      <Paper
        elevation={12}
        sx={{
          overflowY: 'auto',
        }}
      >
        <DialogTitle>
          <Typography variant="h5" component="span">
            Update User
          </Typography>
        </DialogTitle>

        <DialogContent>
          <UserSettingsForm
            ref={formRef}
            isMobile={down_sm}
            userId={userId}
            onInit={(loading) => setLoadingForm(loading)}
            onSubmitting={(loading) => setLoadingSubmit(loading)}
            next={() => {
              onClose(null, 'anyway');
            }}
          />
          <Typography variant="h5" mt={2}>
            Notifications
          </Typography>
          <NotificationsForm userId={userId} isCompact />
        </DialogContent>

        <DialogActions>
          <SubmitButton loading={loading_submit} onClick={onSubmit} />
        </DialogActions>
      </Paper>

      <CloseButton onClick={() => onClose(null, 'anyway')} sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }} />

      <BackdropForDialog loading={loading_form} />
    </Dialog>
  );
};
